<template>
	<v-container fluid>
		<v-row class="pa-3">
			<v-btn color="error" @click="backClick" class="ml-0">
				<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
			</v-btn>
			<v-btn color="success" @click="saveClick(null)" class="ml-2">
				<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
			</v-btn>
			<v-spacer/>
			<v-btn color="primary" @click="newPasswordClick" class="ml-2">
				<v-icon small>fa-lock</v-icon>&nbsp;{{ $t('buttons.setNewPassword') }}
			</v-btn>
		</v-row>
		<v-row v-if="initialLoad && buildingsLoaded">
			<v-col lg="8" cols="12">
				<v-card outlined flat>
					<v-card-text>
						<v-row wrap>
							<v-col cols="12" md="6">
								<InputField
									v-model="user.username"
									:error="userValidation.username"
									:label="'* '+$t('fields.username')"></InputField>
							</v-col>
							<v-col cols="12" md="6">
								<Dropdown
									v-model="user.user_role_id"
									:ajax="true" :data="'user-roles'"
									:error="userValidation.user_role_id"
									:label="'* '+$t('fields.role')"></Dropdown>
							</v-col>
							<v-col v-if="user.id == 0" cols="12" md="6">
								<InputField
									v-model="user.password"
									:error="userValidation.password"
									:label="'* '+$t('fields.password')"></InputField>
							</v-col>
							<v-col cols="12">
								<CheckBox
									v-model="user.active"
									:label="$t('fields.active')"></CheckBox>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<v-row v-if="user.user_role_id == 2 && initialLoad && buildingsLoaded">
			<v-col lg="8" cols="12">
				<v-card outlined flat>
					<v-card-text>
						<v-row wrap>
							<v-col cols="12">
								<Dropdown
									v-model="selectedBuilding"
									:ajax="true" :data="'buildings'"
									:label="$t('labels.selectBuilding')"></Dropdown>
							</v-col>
							<v-col cols="12" lg="6" v-for="(building, key) in user.buildings" :key="key">
								<v-card outlined flat>
									<v-card-title class="pa-2 pb-0">
										<v-col class="pa-0">{{ buildings[building.id].code }} -
											{{ buildings[building.id].street_and_no }},
											{{ buildings[building.id].city }}
										</v-col>
										<v-btn icon @click="removeBuildingClick(key)">
											<v-icon small>fa-trash</v-icon>
										</v-btn>
									</v-card-title>
									<v-card-text class="pa-0">
										<v-col cols="12" class="pt-0">
											<CheckBox
												v-model="building.manager"
												:label="$t('fields.manager')"></CheckBox>
										</v-col>
										<v-col cols="12" class="pa-0 pl-1 pb-1" v-if="!building.manager">
											<Tags
												v-model="building.spaces"
												:hint="$t('labels.addSpacesWithTab')"
												:label="$t('fields.spaces')"></Tags>
										</v-col>
									</v-card-text>
								</v-card>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import InputField from "./trinkets/InputField"
import CheckBox from "./trinkets/CheckBox";
import Dropdown from "./trinkets/Dropdown";
import Tags from "./trinkets/Tags";
import User from "../models/User";

export default {
	name: "UserAccount",
	components: {CheckBox, InputField, Dropdown, Tags},
	data: function () {
		return {
			user: new User({id: this.$route.params.id}),
			userValidation: new User({}, true),
			initialLoad: false,
			changesHappened: false,
			selectedBuilding: null,
			buildingsLoaded: false,
			buildings: []
		}
	},
	watch: {
		user: {
			handler: function () {
				if (this.initialLoad) {
					this.changesHappened = true;
				}
			},
			deep: true
		},
		"user.user_role_id": {
			handler: function () {
				if (this.initialLoad) {
					this.user.buildings = [];
				}
			},
			deep: true
		},
		selectedBuilding: {
			handler: function () {
				if (this.initialLoad && this.selectedBuilding != null) {
					for (let building of this.user.buildings) {
						if (building.id == this.selectedBuilding) {
							this.$alert(this.$t('alerts.buildingExists'));
							this.$nextTick(() => {
								this.selectedBuilding = null;
							});
							return false;
						}
					}
					let newBuilding = {
						id: this.selectedBuilding,
						manager: false,
						spaces: []
					}
					this.user.buildings.push(newBuilding);
					this.$nextTick(() => {
						this.selectedBuilding = null;
					});
				}
			},
			deep: true
		},
	},
	methods: {
		newPasswordClick() {
			let vm = this;
			this.$prompt(this.$t('labels.enterNewPassword'), '', function (result) {
				if (result != '') {
					if (result.length >= 8) {
						vm.$APICall('post', 'users/set-password', {
							username: vm.user.username,
							password: result
						}, (data, success) => {
							if (success) {
								vm.$alert(vm.$t('alerts.passwordSetSuccess'));
							}
						});
					} else {
						vm.$alert(vm.$t('alerts.passwordLength'));
					}
				} else {
					vm.$alert(vm.$t('alerts.passwordMissing'));
				}
			});
		},
		backClick() {
			this.$router.go(-1);
		},
		removeBuildingClick(key) {
			this.$verify(this.$t('alerts.buildingRemoveQuestion'), (result) => {
				if (result) {
					this.user.buildings.splice(key, 1);
				}
			});
		},
		saveClick(after = null) {
			let success = true;

			if (this.user.id == 0) {
				if (this.user.password.trim() == '') {
					success = false;
					this.userValidation.password = this.$t('alerts.fieldMissing');
				} else {
					if (this.user.password.length < 8) {
						success = false;
						this.userValidation.password = this.$t('alerts.passwordLength');
					} else {
						this.userValidation.password = '';
					}
				}
			}

			if (this.user.username == '') {
				success = false;
				this.userValidation.username = this.$t('alerts.fieldMissing');
			} else {
				this.userValidation.username = '';
			}

			if (this.user.user_role_id == null) {
				success = false;
				this.userValidation.user_role_id = this.$t('alerts.fieldMissing');
			} else {
				this.userValidation.user_role_id = '';
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.user.id != 0) {
					action = 'put';
					addition = '/' + vm.user.id;
				}
				this.$APICall(action, 'users' + addition, this.user, (data, success) => {
					if (success) {
						vm.changesHappened = false;
						if (vm.user.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						vm.$triggerReload();
						if (after !== null) {
							after();
						} else {
							vm.backClick();
						}
					} else {
						vm.$alert(vm.$t('alerts.userExists'));
					}
				});
			}
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		let vm = this;
		let payload = {
			pagination: {
				page: 1,
				itemsPerPage: 999999999,
				sortBy: ['id'],
				sortDesc: false
			},
			search: {}
		}
		this.$APICall('get', 'buildings', payload, (data, success) => {
			if (success) {
				let buildings = [];
				for (let building of data.items) {
					buildings[building.id] = building;
				}
				vm.buildings = buildings;
				vm.$nextTick(() => {
					vm.buildingsLoaded = true;
				});
			}
		});
		if (this.user.id != 0) {
			this.$APICall('get', 'users/' + this.user.id, {}, (data, success) => {
				if (success) {
					vm.$myStore.commit('setBreadcrumbs', [
						{text: vm.$t('modules.userAccounts'), href: '/#/user-accounts', disabled: false},
						{text: vm.user.username, href: '/#/user-accounts/' + vm.user.id, disabled: true}
					]);
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
					vm.user = data;
				}
			});
		} else {
			this.$myStore.commit('setBreadcrumbs', [
				{text: this.$t('modules.userAccounts'), href: '/#/user-accounts', disabled: false},
				{text: this.$t('modules.newUserAccount'), href: '/#/user-accounts/0', disabled: true}
			]);
			this.initialLoad = true;
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.changesHappened) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				next(result);
			});
		} else {
			next(true);
		}
	}
}
</script>

<style scoped>

</style>
